export const BUY_PRO_MODAL_IMAGE_URL = "/api/v2/static/media/upgrade-tariff/pro-upgrade.png";

export const BUY_PRO_MODAL_BUTTON_TRANSLATION_KEY = "buyProModal.button";

export const BUY_PRO_MODAL_TEXT_BY_FEATURE = {
    vote: {
        titleKey: "buyProModal.voteTitle",
        descriptionKey: "buyProModal.voteDescription",
    },
    comments: {
        titleKey: "buyProModal.commentsTitle",
        descriptionKey: "buyProModal.commentsDescription",
    },
    presentation: {
        titleKey: "buyProModal.presentationTitle",
        descriptionKey: "buyProModal.presentationDescription",
    },
    export: {
        titleKey: "buyProModal.exportTitle",
        descriptionKey: "buyProModal.exportDescription",
    },
} as const;

export type BuyProModalFeature = keyof typeof BUY_PRO_MODAL_TEXT_BY_FEATURE;
